<template>
	<svg
		:width="size"
		:height="size"
		viewBox="0 0 20 20"
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		role="img"
		:aria-hidden="ariaHidden"
	>
		<path
			d="M10 18.3333C14.6024 18.3333 18.3333 14.6023 18.3333 9.99996C18.3333 5.39759 14.6024 1.66663 10 1.66663C5.39763 1.66663 1.66667 5.39759 1.66667 9.99996C1.66667 14.6023 5.39763 18.3333 10 18.3333Z"
			:fill="computedFill"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M7.5 10L9.16667 11.6667L12.5 8.33337"
			:stroke="computedCheckStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
</template>

<script>
export default {
	name: 'IconCheckCircle',
	props: {
		size: {
			type: [Number, String],
			default: 20
		},
		color: {
			type: String,
			default: 'currentColor'
		},
		filled: {
			type: Boolean,
			default: false
		},
		checkColor: {
			type: String,
			default: '#ffffff'
		},
		strokeWidth: {
			type: [Number, String],
			default: 1.65
		},
		ariaHidden: {
			type: Boolean,
			default: true
		}
	},
	computed: {
		computedFill() {
			return this.filled ? this.color : 'none'
		},
		computedStroke() {
			return this.color
		},
		computedCheckStroke() {
			return this.filled ? this.checkColor : this.color
		}
	}
}
</script>
